
export default {
  async asyncData({ $content, app: { i18n: { locale }, $seoMeta } }) {
    const page = await $content(locale, 'pages/home').fetch()
    $seoMeta.update($seoMeta.page(page.seo))

    return { page }
  }
}
